import { useState } from 'react';
import { Link } from 'react-router-dom';
import CreatorSidebar from '../../components/feature/CreatorSidebar';

interface Message {
  id: number;
  text: string;
  sender: 'me' | 'fan';
  time: string;
  isRead: boolean;
}

interface Chat {
  id: number;
  fanName: string;
  fanAvatar: string;
  lastMessage: string;
  lastMessageTime: string;
  unreadCount: number;
  subscriptionLevel: number;
  messages: Message[];
}

export default function CreatorChat() {
  const [selectedChat, setSelectedChat] = useState<Chat | null>(null);
  const [showChatModal, setShowChatModal] = useState(false);
  const [messageText, setMessageText] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const chats: Chat[] = [
    {
      id: 1,
      fanName: '유저123',
      fanAvatar: 'https://public.readdy.ai/ai/img_res/e641879ff8f41ad07ffd2585f6b87676.jpg',
      lastMessage: '안녕하세요! 항상 좋은 콘텐츠 감사합니다 💕',
      lastMessageTime: '5분 전',
      unreadCount: 2,
      subscriptionLevel: 3,
      messages: [
        { id: 1, text: '안녕하세요! 팬이에요 😊', sender: 'fan', time: '오전 10:30', isRead: true },
        { id: 2, text: '안녕하세요! 반가워요!', sender: 'me', time: '오전 10:32', isRead: true },
        { id: 3, text: '항상 좋은 콘텐츠 감사합니다 💕', sender: 'fan', time: '오전 10:35', isRead: false },
        { id: 4, text: '다음 콘텐츠도 기대해주세요!', sender: 'fan', time: '오전 10:36', isRead: false }
      ]
    },
    {
      id: 2,
      fanName: '팬456',
      fanAvatar: 'https://readdy.ai/api/search-image?query=korean%20male%20fan%20profile%20picture%20with%20natural%20lighting%20casual%20style%20professional%20photo%20clean%20background&width=200&height=200&seq=fan2chat&orientation=squarish',
      lastMessage: '다음 화보 언제 나오나요?',
      lastMessageTime: '1시간 전',
      unreadCount: 0,
      subscriptionLevel: 4,
      messages: [
        { id: 1, text: '안녕하세요!', sender: 'fan', time: '어제', isRead: true },
        { id: 2, text: '다음 화보 언제 나오나요?', sender: 'fan', time: '1시간 전', isRead: true }
      ]
    },
    {
      id: 3,
      fanName: '구독자789',
      fanAvatar: 'https://readdy.ai/api/search-image?query=korean%20female%20subscriber%20profile%20photo%20with%20bright%20lighting%20happy%20expression%20professional%20headshot%20clean%20background&width=200&height=200&seq=fan3chat&orientation=squarish',
      lastMessage: '후원 보냈어요! 화이팅!',
      lastMessageTime: '3시간 전',
      unreadCount: 1,
      subscriptionLevel: 5,
      messages: [
        { id: 1, text: '후원 보냈어요! 화이팅!', sender: 'fan', time: '3시간 전', isRead: false }
      ]
    },
    {
      id: 4,
      fanName: '열혈팬',
      fanAvatar: 'https://readdy.ai/api/search-image?query=korean%20male%20enthusiastic%20fan%20profile%20picture%20with%20energetic%20expression%20professional%20photo%20clean%20background&width=200&height=200&seq=fan4chat&orientation=squarish',
      lastMessage: '오늘 라이브 방송 하시나요?',
      lastMessageTime: '어제',
      unreadCount: 0,
      subscriptionLevel: 2,
      messages: [
        { id: 1, text: '오늘 라이브 방송 하시나요?', sender: 'fan', time: '어제', isRead: true },
        { id: 2, text: '오늘은 어려울 것 같아요 ㅠㅠ', sender: 'me', time: '어제', isRead: true }
      ]
    },
    {
      id: 5,
      fanName: '신규팬',
      fanAvatar: 'https://readdy.ai/api/search-image?query=korean%20female%20new%20subscriber%20profile%20photo%20with%20gentle%20lighting%20sweet%20smile%20professional%20headshot%20clean%20background&width=200&height=200&seq=fan5chat&orientation=squarish',
      lastMessage: '구독했어요! 잘 부탁드려요',
      lastMessageTime: '2일 전',
      unreadCount: 0,
      subscriptionLevel: 1,
      messages: [
        { id: 1, text: '구독했어요! 잘 부탁드려요', sender: 'fan', time: '2일 전', isRead: true },
        { id: 2, text: '감사합니다! 앞으로 좋은 콘텐츠로 보답할게요 💕', sender: 'me', time: '2일 전', isRead: true }
      ]
    }
  ];

  const filteredChats = chats.filter(chat =>
    chat.fanName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleSendMessage = () => {
    if (!messageText.trim()) return;
    
    alert('메시지가 전송되었습니다!');
    setMessageText('');
  };

  const openChatModal = (chat: Chat) => {
    setSelectedChat(chat);
    setShowChatModal(true);
  };

  const closeChatModal = () => {
    setShowChatModal(false);
    setMessageText('');
  };

  const getLevelBadge = (level: number) => {
    const levels = [
      { name: '베이직', color: 'bg-gray-100 text-gray-700' },
      { name: '스탠다드', color: 'bg-blue-100 text-blue-700' },
      { name: '프리미엄', color: 'bg-purple-100 text-purple-700' },
      { name: 'VIP', color: 'bg-pink-100 text-pink-700' },
      { name: '다이아몬드', color: 'bg-gradient-to-r from-pink-500 to-purple-500 text-white' }
    ];
    return levels[level - 1] || levels[0];
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-pink-50 to-purple-50">
      <CreatorSidebar />
      
      <div className="lg:ml-64 p-4 lg:p-8">
        <div className="max-w-7xl mx-auto">
          {/* 헤더 */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-2">메시지</h1>
            <p className="text-gray-600">팬들과 소통하세요</p>
          </div>

          {/* 검색 */}
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 border border-pink-100 shadow-lg mb-6">
            <div className="relative">
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg"></i>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="팬 검색..."
                className="w-full pl-12 pr-4 py-3 rounded-xl border border-gray-200 focus:border-pink-400 focus:ring-2 focus:ring-pink-200 outline-none transition-all text-sm"
              />
            </div>
          </div>

          {/* 메시지 목록 */}
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl border border-pink-100 shadow-lg overflow-hidden">
            {filteredChats.length === 0 ? (
              <div className="text-center py-12 px-4">
                <i className="ri-message-3-line text-4xl text-gray-300 mb-3"></i>
                <p className="text-gray-500">검색 결과가 없습니다</p>
              </div>
            ) : (
              <div className="divide-y divide-gray-100">
                {filteredChats.map((chat) => (
                  <button
                    key={chat.id}
                    onClick={() => openChatModal(chat)}
                    className="w-full p-6 flex items-start gap-4 hover:bg-pink-50/50 transition-all cursor-pointer"
                  >
                    <div className="relative flex-shrink-0">
                      <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-pink-200">
                        <img
                          src={chat.fanAvatar}
                          alt={chat.fanName}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      {chat.unreadCount > 0 && (
                        <div className="absolute -top-1 -right-1 w-6 h-6 bg-pink-500 rounded-full flex items-center justify-center">
                          <span className="text-xs text-white font-bold">{chat.unreadCount}</span>
                        </div>
                      )}
                    </div>
                    <div className="flex-1 text-left min-w-0">
                      <div className="flex items-center justify-between mb-2">
                        <h3 className="font-bold text-gray-800 text-lg">{chat.fanName}</h3>
                        <span className="text-sm text-gray-500 flex-shrink-0 ml-2">{chat.lastMessageTime}</span>
                      </div>
                      <div className="mb-2">
                        <span className={`text-xs px-3 py-1 rounded-full ${getLevelBadge(chat.subscriptionLevel).color}`}>
                          {getLevelBadge(chat.subscriptionLevel).name}
                        </span>
                      </div>
                      <p className={`text-sm truncate ${chat.unreadCount > 0 ? 'text-gray-800 font-semibold' : 'text-gray-500'}`}>
                        {chat.lastMessage}
                      </p>
                    </div>
                    <i className="ri-arrow-right-s-line text-2xl text-gray-400 flex-shrink-0"></i>
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* 채팅 팝업 */}
      {showChatModal && selectedChat && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-3xl max-w-2xl w-full h-[80vh] flex flex-col">
            {/* 헤더 */}
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-pink-200">
                  <img src={selectedChat.fanAvatar} alt={selectedChat.fanName} className="w-full h-full object-cover" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-800">{selectedChat.fanName}</h3>
                  <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold ${getLevelBadge(selectedChat.subscriptionLevel).color}`}>
                    <i className="ri-vip-crown-fill"></i>
                    {getLevelBadge(selectedChat.subscriptionLevel).name}
                  </span>
                </div>
              </div>
              <button
                onClick={closeChatModal}
                className="w-10 h-10 rounded-full hover:bg-gray-100 flex items-center justify-center transition-all cursor-pointer"
              >
                <i className="ri-close-line text-2xl text-gray-600"></i>
              </button>
            </div>

            {/* 메시지 영역 */}
            <div className="flex-1 overflow-y-auto p-6 space-y-4">
              {selectedChat.messages.map((message) => (
                <div
                  key={message.id}
                  className={`flex ${message.sender === 'me' ? 'justify-end' : 'justify-start'}`}
                >
                  <div className={`max-w-[70%] ${message.sender === 'me' ? 'order-2' : 'order-1'}`}>
                    <div
                      className={`px-4 py-2 rounded-2xl ${
                        message.sender === 'me'
                          ? 'bg-gradient-to-r from-pink-500 to-purple-500 text-white'
                          : 'bg-gray-100 text-gray-800'
                      }`}
                    >
                      <p className="text-sm">{message.text}</p>
                    </div>
                    <div className={`flex items-center gap-1 mt-1 text-xs text-gray-500 ${message.sender === 'me' ? 'justify-end' : 'justify-start'}`}>
                      <span>{message.time}</span>
                      {message.sender === 'me' && (
                        <i className={`${message.isRead ? 'ri-check-double-line text-pink-500' : 'ri-check-line'}`}></i>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* 메시지 입력 */}
            <div className="p-6 border-t border-gray-200">
              <div className="flex items-end gap-3">
                <button className="w-10 h-10 flex items-center justify-center hover:bg-gray-100 rounded-full transition-colors flex-shrink-0 cursor-pointer">
                  <i className="ri-image-add-line text-xl text-gray-600"></i>
                </button>
                <div className="flex-1">
                  <textarea
                    value={messageText}
                    onChange={(e) => setMessageText(e.target.value)}
                    placeholder="메시지를 입력하세요..."
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-pink-500 resize-none text-sm"
                    rows={1}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter' && !e.shiftKey) {
                        e.preventDefault();
                        handleSendMessage();
                      }
                    }}
                  />
                </div>
                <button
                  onClick={handleSendMessage}
                  disabled={!messageText.trim()}
                  className="w-10 h-10 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-full flex items-center justify-center hover:shadow-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0 cursor-pointer"
                >
                  <i className="ri-send-plane-fill"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
